import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "staff_access_token";
export const getToken = () => { try { return localStorage.getItem(TOKEN_KEY); } catch { return null; } };
export const setToken = (t) => { try { localStorage.setItem(TOKEN_KEY, t); } catch {} };
export const clearToken = () => { try { localStorage.removeItem(TOKEN_KEY); } catch {} };

const api = axios.create({ baseURL: API, withCredentials: true });

// Jeton porté par l'en-tête Authorization (indépendant des cookies).
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else delete config.headers.Authorization;
  return config;
});

// Session expirée / non connecté : nettoyer le jeton et rediriger vers la connexion sans toast.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const url = error.config?.url || "";
    const status = error.response?.status;
    const isAuthEndpoint = /\/auth\/(login|staff-login|me|refresh|logout)/.test(url);
    if (status === 401 && !isAuthEndpoint) {
      clearToken();
      if (!window.location.pathname.startsWith("/login")) {
        window.location.assign("/login");
      }
      return new Promise(() => {}); // ne se résout jamais → aucun toast d'erreur
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function logEvent(payload) {
  api.post("/stats/event", payload).catch(() => {});
}

export default api;
